/*This component comes into action after clicking Connect button on Fundraiser Page*/

import {
	Component,
	OnInit,
	ChangeDetectorRef,
	AfterContentChecked,
} from '@angular/core';
import {
	AbstractControl,
	AsyncValidatorFn,
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	ValidationErrors,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import {
	DatePipe,
	NgIf,
	NgClass,
	NgFor,
	NgStyle,
	DecimalPipe,
} from '@angular/common';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { MediaFiles } from '../../../models/mediaFiles';
import { DomSanitizer } from '@angular/platform-browser';
import { PreviewVideo } from '../../../models/previewVideo';
import { DashboardService } from 'src/app/pages/user/dashboard/services/dashboard.service';
import { Tools } from 'src/utilities/tools';
import { ProfileService } from 'src/app/pages/user/profile/services/profile.service';
import { AnalyticsService } from 'src/app/global/services/analytics.service';
import {
	debounceTime,
	distinctUntilChanged,
	switchMap,
	catchError,
	filter,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { CharacterNormalizationService } from '../../../services/character-normalization.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';

@Component({
	selector: 'app-connect-fundraiser',
	templateUrl: './connect-fundraiser.component.html',
	styleUrls: ['./connect-fundraiser.component.scss'],
	standalone: true,
	imports: [
		NgIf,
		PageLoaderComponent,
		FormsModule,
		ReactiveFormsModule,
		NgClass,
		ExtendedModule,
		FlexModule,
		MatFormFieldModule,
		MatInputModule,
		TextFieldModule,
		MatButtonModule,
		NgFor,
		MatCardModule,
		NgStyle,
		MatDatepickerModule,
		MatProgressSpinnerModule,
		DecimalPipe,
	],
	providers: [DatePipe],
})

/*
 * This component takes care of creating a new connected fundraiser-------------------------------------------------------------
 */
export class ConnectFundraiserComponent implements OnInit {
	/*
	 * Global Variables----------------------------------------------------------
	 */
	isLoading: boolean = false;
	slug: string = '';
	connectFundraiserForm!: UntypedFormGroup;
	parentFundraiser: any;
	imageFiles: File[] = new Array<File>();
	imgUrl: any[] = new Array<any>();
	isVideo: boolean = false;
	embedVideoUrl: any[] = new Array<any>();
	mediaFiles: MediaFiles[] = new Array<MediaFiles>();
	disableVideoSaveButton: boolean = true;
	profileResponse: any;
	minEndDate: Date = new Date();
	locale: any;
	currencyCode: string = '';
	currencySymbol: string = '';
	currencyConversionFactor: number = 1;
	maxTargetAmount: number = 99;
	ConnectedFundraiserTitle = $localize`:@@connected_fundraiser_fund_title: Fundraiser Title`;
	connectedFundraiserMotivation = $localize`:@@connected_fundraiser_fund_motivation: Fundraiser Motivation`;
	connectedFundraiserYoutubeLink = $localize`:@@connected_fundraiser_youtube_link_Input: Youtube Link`;
	connectedFundraiserLinkName = $localize`:@@connected_fundraiser_link_name_Input: Link name`;
	isEditingSlug: boolean = false;

	/*
	 * Constructor Function------------------------------------------------------
	 * @param router
	 * @param notificationService
	 * @param fundraiserService
	 * @param datepipe
	 * @param accountService
	 * @param sanitizer
	 */
	constructor(
		public router: Router,
		public notificationService: NotificationService,
		public fundraiserService: FundraiserService,
		public datepipe: DatePipe,
		public accountService: AccountService,
		public sanitizer: DomSanitizer,
		public formBuilder: UntypedFormBuilder,
		public _dashboardService: DashboardService,
		public cdref: ChangeDetectorRef,
		public profileService: ProfileService,
		public analyticsService: AnalyticsService,
		public charNormalizationService: CharacterNormalizationService
	) {
		// Define the form group
		this.defineFormGroup();
	}

	// Function to define the form group
	private defineFormGroup(): void {
		this.connectFundraiserForm = new UntypedFormGroup({
			title: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(5),
				Validators.maxLength(75),
				Validators.pattern(
					/^[\p{L}\p{N}\p{P}\p{S}\s\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAC0}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{2B05}\u{1F004}]*$/u
				),
			]),
			description: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(150),
				Validators.maxLength(15000),
			]),
			custom_url: new UntypedFormControl('', {
				validators: [
					Validators.required,
					Validators.minLength(1),
					Validators.maxLength(75),
					Validators.pattern('^[a-zA-Z0-9_\\s-]*$'),
				],
				asyncValidators: [this.isSlugUnique()],
			}),
			target_amount: new UntypedFormControl('', [
				Validators.max(this.maxTargetAmount),
				Validators.pattern('^[0-9]+$'),
			]),
			end_date: new UntypedFormControl(),
			youtube_link: new UntypedFormControl('', []),
		});
	}

	/*
	 * Lifecycle Hooks~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */
	ngOnInit(): void {
		this.checkLoginStatus();
	}

	// Function to check if the slug is present and not null or undefined
	private isSlugPresent(): boolean {
		const urlSegments = this.router.url.split('/');
		const slug = urlSegments[urlSegments.length - 1]; // Assuming the slug is the last segment in the URL
		return (
			slug !== undefined &&
			slug !== null &&
			slug.trim() !== '' &&
			slug !== 'null'
		);
	}

	// Function to check login status and navigate to login screen if not logged in
	private checkLoginStatus(): void {
		this.accountService.getLoginInformation().subscribe(
			(info) => {
				const currentPath = this.router.url;
				if (!info) {
					localStorage.setItem('previous_path', currentPath); // store the path before redirecting
					this.router.navigate(['account/register']);
				} else {
					this.handleLoggedInUser();
				}
			},
			(error: any) => {
				console.error('Error checking login information:', error);
			}
		);
	}

	// Function to handle actions for logged-in users
	private handleLoggedInUser(): void {
		if (this.isSlugPresent()) {
			this.locale = this.accountService.getLocaleId();
			this.fetchProfile();
			this.extractSlug();
			this.getParentFundraiser();
			this.subscribeToCustomUrlChanges();
		} else {
			this.router.navigate(['search']);
		}
	}

	// Function to fetch profile information
	private fetchProfile(): void {
		if (this.accountService.checkHeaders()) {
			this.profileService.getProfile().subscribe(
				(res: any) => {
					this.profileResponse = res?.data;
				},
				(error: any) => {
					console.error('Error fetching profile:', error);
				}
			);
		}
	}

	// Function to extract slug from the URL
	private extractSlug(): void {
		this.slug = this.router.url.substring(21);
	}

	// Function to get parent fundraiser details
	private getParentFundraiser(): void {
		this.fundraiserService
			.getFundraiserBySlug(this.slug, this.locale)
			.subscribe(
				(response: any) => {
					if (response['status'] === '404') {
						this.notificationService.openNotification(
							$localize`:@@connect_fundraiser_fundraiserNotFound_notification:Fundraiser Not found. Error: ` +
								response['error']['errors']['message'],
							'',
							'error'
						);
					} else {
						this.parentFundraiser = response['data']?.result;
						this.isLoading = true;
						this.setCurrencyDetails();
						this.updateTargetAmountValidators();
					}
				},
				(error: any) => {
					console.error('Error fetching parent fundraiser:', error);
				}
			);
	}

	// Function to set currency details
	private setCurrencyDetails(): void {
		this.currencyCode = this.parentFundraiser?.currency_code;
		this.currencySymbol = this.parentFundraiser?.currency_symbol;
		this.currencyConversionFactor =
			this.parentFundraiser?.custom_donation_configuration?.x_to_eur;
		this.maxTargetAmount = this.currencyConversionFactor * 999999;
	}

	// Function to update target amount validators
	private updateTargetAmountValidators(): void {
		const updatedValidators = [
			Validators.pattern('^[0-9]+$'),
			Validators.max(this.maxTargetAmount),
		];
		this.connectFundraiserForm.controls.target_amount.setValidators(
			updatedValidators
		);
	}

	// Function to subscribe to custom_url changes with debounce
	private subscribeToCustomUrlChanges(): void {
		this.connectFundraiserForm
			.get('custom_url')
			?.valueChanges.pipe(
				debounceTime(600), // Wait for 0.6 seconds after the last keystroke
				distinctUntilChanged(), // Ensure the value actually changed
				filter((slug: string) => /^[a-zA-Z0-9_\\s-]*$/.test(slug)),
				switchMap((slug: string) => {
					// Return an observable for the API call to check slug uniqueness
					return this.fundraiserService.isSlugUnique(slug).pipe(
						catchError(() => of(null)) // Gracefully handle errors
					);
				})
			)
			.subscribe(
				(result: any) => {
					if (result?.data?.slug_in_use) {
						this.connectFundraiserForm
							.get('custom_url')
							?.setErrors({ slugInUse: true });
					} else {
						this.connectFundraiserForm.get('custom_url')?.setErrors(null);
					}
				},
				(error: any) => {
					console.error('Error checking slug uniqueness:', error);
				}
			);
	}

	ngAfterContentChecked() {
		this.cdref.detectChanges();
	}

	/*
	 * SLUG FUNCTIONS~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	/*
	 * Function to replace space in slug with hyphen------------------------------
	 * @param slug
	 */
	// setSlug(slug: string) {
	// 	let newVal = slug.replace(/\s+/g, '-');
	// 	this.connectFundraiserForm?.controls['custom_url'].setValue(
	// 		newVal.toLowerCase()
	// 	);
	// 	this.connectFundraiserForm?.controls['custom_url'].markAsTouched();
	// }

	setSlug(event: Event): void {
		const input = event.target as HTMLInputElement;
		let slug = input.value;

		// Normalize and remove emojis
		const normalized = this.charNormalizationService.normalizeString(slug);
		const sanitized = this.removeEmojis(normalized);

		// Replace whitespace with hyphens
		const slugified = sanitized.trim().toLowerCase().replace(/\s+/g, '-');

		// Always sanitize the input field, even if user is editing it
		this.connectFundraiserForm?.controls['custom_url'].setValue(slugified, {
			emitEvent: false,
		});

		// Only mark controls touched if auto-setting slug
		if (!this.isEditingSlug) {
			const controlNames = ['custom_url', 'title'];
			controlNames.forEach((controlName) => {
				this.connectFundraiserForm.controls[controlName].markAsTouched();
			});
		}
	}

	/*
	 * Validator Function to check if slug is unique-------------------------------
	 * @returns
	 */
	isSlugUnique(): AsyncValidatorFn {
		return (control: AbstractControl) => {
			const validationPromise: Promise<ValidationErrors | null> = new Promise(
				(resolve, reject) => {
					this.fundraiserService.isSlugUnique(control.value).subscribe(
						(result: any) => {
							if (result['data']['slug_in_use']) {
								resolve({ custom_url: 'slugInUse' });
							} else {
								resolve(null);
							}
						},
						(error) => {
							resolve(null);
						}
					);
				}
			);
			return validationPromise;
		};
	}

	/*
	 * Convert data uri to blob-----------------------------------------------
	 */
	dataURItoBlob(dataURI: any) {
		var byteString = atob(dataURI.toString().split(',')[1]);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], { type: 'image/jpeg' });
		//return new File([blob], 'blob', { type: 'image/jpeg;charset=utf-8' });
	}

	/*
	 * Function to save connected Fundraiser-------------------------------------------------
	 */
	saveAndContinue() {
		this.connectFundraiserForm.markAllAsTouched();
		if (this.connectFundraiserForm.valid) {
			this.isLoading = false;

			/** *Check for unlimited */
			let unlimited: boolean = false;
			let amount_target: string =
				this.connectFundraiserForm.get('target_amount')?.value;
			if (
				amount_target == null ||
				amount_target == undefined ||
				amount_target.length <= 0 ||
				amount_target == '0'
			) {
				unlimited = true;
				amount_target = '0';
			}

			/** *Retrieve end_date in proper format */
			let end_date = this.datepipe.transform(
				this.connectFundraiserForm.get('end_date')?.value,
				'yyyy-MM-dd'
			);
			if (end_date == null || end_date == undefined) {
				end_date = '9999-12-31';
			}

			let location_local =
				this.parentFundraiser?.root_funraiser == undefined
					? this.parentFundraiser?.location?.location_name
					: this.parentFundraiser?.root_funraiser?.location?.location_name;

			/** *Create Object To Pass To API */
			let connectedFundraiser: Object;

			connectedFundraiser = {
				title: this.connectFundraiserForm.get('title')?.value,
				slug: this.connectFundraiserForm.get('custom_url')?.value,
				category_id: this.parentFundraiser?.category?.id,
				description: this.connectFundraiserForm.get('description')?.value,
				location_local: location_local,
				language_code: this.parentFundraiser?.language_code,
				unlimited: unlimited,
				appeal: `<p>${(
					this.connectFundraiserForm.get('description')?.value || ''
				).trim()}</p>`,
				currency_code: this.currencyCode,
				end_date: end_date,
				show_donation_details: true,
				allow_child: true,
				tip_enabled: true,
				is_draft: false,
				created_on: (() => {
					const currentUrl = window.location.origin;
					return currentUrl.includes('localhost')
						? 'https://whydonate.in'
						: currentUrl;
				})(),
				parent_id: this.parentFundraiser?.id,
				amount_target: amount_target,
			};

			if (this.accountService.checkHeaders()) {
				this.fundraiserService
					.createConnectedFundraiser(connectedFundraiser)
					.subscribe(
						async (data: any) => {
							/** *UPLOAD IMAGES IF AVAILABLE */
							if (this.mediaFiles.length > 0) {
								let multimediaData = new FormData();
								this.mediaFiles.forEach((file, index) => {
									if (file.isImage == true) {
										multimediaData.append(
											'image' + index,
											this.base64toBlob(
												this.imgUrl[index],
												this.imageFiles[index].type
											)
										);
									}
									if (file.isVideo == true) {
										multimediaData.append(
											'video' + index,
											this.mediaFiles[index]['videoUrl']
										);
									}
								});

								multimediaData.append('slug', data['data']['slug']);
								multimediaData.append('text', 'appeal');

								this.fundraiserService
									.uploadAppealImageList(multimediaData)
									.subscribe(
										(data: any) => {
											this.notificationService.openNotification(
												$localize`:@@connect_fundraiser_fundraiserConnected_notification:Fundraiser connected successfully`,
												'close',
												'success'
											);
											this.isLoading = false;
											/** *Route to just created fundraiser */
											this.router.navigate([
												'/fundraising/' +
													this.connectFundraiserForm.get('custom_url')?.value,
											]);
										},
										(error) => {
											this.notificationService.openNotification(
												$localize`:@@connect_fundraiser_fundraiserConnectedNoImages_notification:Fundraiser connected succesfully but images are not uploaded.`,
												'close',
												'error'
											);
										}
									);
							}

							this.notificationService.openNotification(
								$localize`:@@connect_fundraiser_fundraiserConnected_notification:Fundraiser connected successfully`,
								'',
								'success'
							);

							//Google Analytics Event
							this.analyticsService.fireAnalyticsEvent('Connected_Created', {
								profile_id: (await this.accountService.getProfileId()) || 0,
								user_id:
									JSON.parse(localStorage.getItem('user') || '{}')?.id || 0,
								fundraiser_id: data?.data?.id,
							});

							this.isLoading = false;
							/** *Route to just created fundraiser */
							this.router.navigate([
								'/fundraising/' +
									this.connectFundraiserForm.get('custom_url')?.value,
							]);
						},
						(error) => {
							this.notificationService.openNotification(
								$localize`:@@connect_fundraiser_errorsInForm_notification:There are errors in creating fundraiser.`,
								'close',
								'error'
							);
						}
					);
			}
		} else {
			this.notificationService.openNotification(
				$localize`:@@connect_fundraiser_errorsInForm_notification:There are errors in your form. Kindly fill the form properly.`,
				'close',
				'error'
			);
		}
	}

	/** *Get Base 64 Image */
	async getBase64ImageFromUrl(imageUrl: string) {
		var res = await fetch(imageUrl);
		var blob = await res.blob();

		return new Promise((resolve, reject) => {
			var reader = new FileReader();
			reader.addEventListener(
				'load',
				function () {
					resolve(reader.result);
				},
				false
			);

			reader.onerror = () => {
				return reject(this);
			};
			reader.readAsDataURL(blob);
		});
	}

	/*
	 * Image File Functions~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */
	onFileChange(event: any) {
		if (this.mediaFiles.length > 2) {
			this.notificationService.openNotification(
				$localize`:@@connect_fundraiser_addMoreThan3Files_notifications:You can not add more than 3 media files.`,
				'close',
				'error'
			);
		} else {
			let file = event.target.files[0];
			if (file) {
				if (file.size < 5242880) {
					if (
						file.type == 'image/jpg' ||
						file.type == 'image/jpeg' ||
						file.type == 'image/png' ||
						file.type == 'image/webp'
					) {
						this.imageFiles.push(file);
						this.previewUploadedImage(file);
					} else {
						this.notificationService.openNotification(
							$localize`:@@connect_fundraiser_formatFile_notification:One of your image file is not jpg or png. Please choose a different file.`,
							'OK',
							'error'
						);
					}
				} else {
					this.notificationService.openNotification(
						$localize`:@@connect_fundraiser_oneImageIsGreaterThan5mb_notification:One of your image file is greater than 5mb. Please choose a different file.`,
						'OK',
						'error'
					);
				}
			}
		}
	}

	/*
	 * Function to preview uploaded images-------------------------------------------------------
	 */
	previewUploadedImage(file: File) {
		var reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = (_event) => {
			this.imgUrl.push(reader.result);
			this.mediaFiles.push(new MediaFiles(true, false, reader.result, ''));
		};
	}

	/*
	 * Convert base 64 to blob--------------------------------------------------------
	 */

	base64toBlob(base64Data: any, contentType: any): string | Blob {
		try {
			const base64ImageContent = base64Data.replace(
				/^data:image\/(png|jpg|jpeg|webp);base64,/,
				''
			);
			contentType = contentType || '';
			const sliceSize = 1024;
			const byteCharacters = atob(base64ImageContent);
			const bytesLength = byteCharacters.length;
			const slicesCount = Math.ceil(bytesLength / sliceSize);
			const byteArrays = new Array(slicesCount);

			for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				const begin = sliceIndex * sliceSize;
				const end = Math.min(begin + sliceSize, bytesLength);

				const bytes = new Array(end - begin);
				for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0);
				}
				byteArrays[sliceIndex] = new Uint8Array(bytes);
			}
			const imageBlob = new Blob(byteArrays, { type: contentType });
			return imageBlob;
		} catch (e) {
			return '';
		}
	}

	removeImage(imageUrl: any) {
		//Remove from media Files array
		let indexMediaFiles: number = -1;
		this.mediaFiles.forEach((item, indexLoop) => {
			if (item['imageUrl'] == imageUrl) {
				indexMediaFiles = indexLoop;
			}
		});
		if (indexMediaFiles > -1) {
			this.mediaFiles.splice(indexMediaFiles, 1);
		}

		//Remove form imgUrl array
		const index = this.imgUrl.indexOf(imageUrl, 0);
		if (index > -1) {
			this.imgUrl.splice(index, 1);
		}
	}

	/*
	 * Video Function~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	 */

	/*
	 * Function to switch boolean value of video to show video link input field----------------
	 */
	switchIsVideo() {
		this.isVideo = !this.isVideo;
		if (this.isVideo) {
			this.connectFundraiserForm.controls['youtube_link'].addAsyncValidators(
				this.isYouTubeUrl()
			);
		} else {
			this.connectFundraiserForm.controls['youtube_link'].removeAsyncValidators(
				this.isYouTubeUrl()
			);
		}
	}

	/*
	 * Function to check if given link is valid youtube url--------------------------------------
	 * @returns
	 */
	isYouTubeUrl(): AsyncValidatorFn {
		return (control: AbstractControl) => {
			const validationPromise: Promise<ValidationErrors | null> = new Promise(
				(resolve, reject) => {
					let url = control.value;
					var regExp = '^(https?://)?((www.)?youtube.com|youtu.be)/.+$';
					var match = url.match(regExp);
					if (match) {
						this.disableVideoSaveButton = false;
						resolve(null);
					} else {
						this.disableVideoSaveButton = true;
						resolve({ invalid: 'true' });
					}
				}
			);
			return validationPromise;
		};
	}

	/*
	 * Function to save video in media files array---------------------------------------
	 */
	saveVideo() {
		if (this.mediaFiles.length < 3) {
			if (this.connectFundraiserForm.get('youtube_link')?.valid) {
				/* Converting shorts to embed from youtube URL */

				const re = /shorts/gi;
				var str = this.connectFundraiserForm.get('youtube_link')?.value;
				var newstr = str.replace(re, 'embed');
				this.connectFundraiserForm.get('youtube_link')?.setValue(newstr);
				let videoUrl = this.connectFundraiserForm.get('youtube_link')?.value;
				/** *let videoUrl = 'https://www.youtube.com/watch?v=avAHsJgr4m0'; */
				let embedVideoUrl =
					'https://www.youtube.com/embed/' + this.getYouTubeEmbedUrl(videoUrl);
				let sanitizedUrl =
					this.sanitizer.bypassSecurityTrustResourceUrl(embedVideoUrl);
				this.embedVideoUrl.push(new PreviewVideo(sanitizedUrl, videoUrl));
				this.mediaFiles.push(new MediaFiles(false, true, '', videoUrl));
				this.connectFundraiserForm.controls[
					'youtube_link'
				].clearAsyncValidators();
				this.connectFundraiserForm.get('youtube_link')?.setValue('');

				this.isVideo = !this.isVideo;
			} else {
				this.notificationService.openNotification(
					$localize`:@@connect_fundraiser_youtubeUrl_notification:The youtube url you have entered is invalid`,
					'close',
					'error'
				);
			}
		} else {
			this.notificationService.openNotification(
				$localize`:@@connect_fundraiser_notAddMoreThan3Files_notification:You can not add more than 3 media files`,
				'Close',
				'error'
			);
		}
	}

	/*
	 * Function to get embed url of a youtube link--------------------------------------------
	 * @param url
	 * @returns
	 */
	getYouTubeEmbedUrl(url: string) {
		var regExp =
			/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
		var match = url.match(regExp);
		return match && match[1].length == 11 ? match[1] : '';
	}

	/**
	 * Function to remove video from arrays
	 * @param videoObject
	 */
	removeVideo(videoObject: any) {
		//Remove from media Files array
		let indexMediaFiles: number = -1;
		this.mediaFiles.forEach((item, indexLoop) => {
			if (item['videoUrl'] == videoObject['youtubeUrl']) {
				indexMediaFiles = indexLoop;
			}
		});
		if (indexMediaFiles > -1) {
			this.mediaFiles.splice(indexMediaFiles, 1);
		}
		//Remove from preview videos araay
		const index = this.embedVideoUrl.indexOf(videoObject, 0);
		if (index > -1) {
			this.embedVideoUrl.splice(index, 1);
		}
	}
	removeEmojis(text: string): string {
		// Replace spaces with a placeholder
		let result = text.replace(/\s+/g, 'ANTRIKSHY');

		// Match emojis and special characters, excluding hyphens manually
		const emojiAndSpecialCharsRegex =
			/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;

		// Remove emojis
		result = result.replace(emojiAndSpecialCharsRegex, '');

		// Remove punctuation and symbols except hyphens
		result = result.replace(/[^\w\s-]/g, '');

		// Restore hyphens
		result = result.replace(/ANTRIKSHY/g, '-');
		result = result.replace(/-+/g, '-'); // Collapse multiple hyphens

		return result.trim();
	}

	onFocus() {
		this.isEditingSlug = true;
	}
	onBlur() {
		this.isEditingSlug = false;
	}
}
